import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const CTA_KEY = "cta";
const ALERTS_KEY = "alerts";

export const mmgKeys = createKeys(featureKeys.MMG_FEATURE_KEY, {
  cta: () => [CTA_KEY],
  alerts: () => [ALERTS_KEY],
});
